(function () {
    let currentPage = 1;
    const loadMore = document.getElementById("load-more-news");

    if (loadMore != null && loadMore != "undefined") {
        loadMore.addEventListener("click", function (event) {
            currentPage++;
            loadMoreNews();
        });
    }

    function loadMoreNews() {
        jQuery.ajax({
          type: "POST",
          url: globalvars.ajaxurl,
          data: {
            action: "ajax_handler_load_more_news",
            nonce: globalvars.ajax_nonce,
            page: currentPage,
          },
          beforeSend: function beforeSend() {},
          success: function success(data, textStatus, XMLHttpRequest) {
            const response = JSON.parse(data);
    
            document
              .getElementById("news")
              .insertAdjacentHTML("beforeend", response["html"]);
    
            if (response["max"] <= currentPage) {
              loadMore.classList.add("hidden");
            }
          },
          error: function error(MLHttpRequest, textStatus, errorThrown) {
            console.log("loadMoreStores", textStatus, errorThrown);
          },
        });
    }
})();
